import { Component } from '@angular/core';

@Component({
  selector: 'app-news-pr1',
  templateUrl: './pr1.component.html',
  styleUrls: ['./pr1.component.scss']
})
export class NewsPR1Component {}
